import { computed, Ref, SetupContext } from '@vue/composition-api';
import { useMsal } from './useMsal';

export function useIsAuthenticated(context: SetupContext): Ref<boolean> {
    const { accounts } = useMsal(context);
    const isAuthenticated = computed<boolean>(() => accounts.value.length > 0);

    return isAuthenticated;
}
